import JSZip from 'jszip';
/**
 *
 * @param {Array} files
 * files array of objects with the following structure
 * {
 * name: 'name of the file',
 * url: 'url of the file'
 * mimetype: 'mimetype of the file'
 * }
 * @returns {Promise}
 */
export async function downloadFiles(files) {
   if (!files?.length) {
      return;
   }

   let downloadUrl, fileName;

   // if there is only one file, and is not image, download it directly
   if (files.length === 1 && !files[0].mimetype?.includes('image')) {
      downloadUrl = files[0].url;
      fileName = files[0].name;
   }

   // if there is only one file, and is an image, force download and not open in browser
   if (files.length === 1 && files[0].mimetype?.includes('image')) {
      downloadUrl = await fetch(files[0].url).then((r) => r.blob());
      fileName = files[0].name;
   }

   // if there are multiple files, compress them and download the zip file
   if (files.length > 1) {
      const zipFile = await compressFiles(files);
      downloadUrl = zipFile;
      fileName = 'files.zip';
   }

   // download the zip file
   const link = document.createElement('a');
   let objectUrl;
   if (typeof downloadUrl === 'string') {
      link.href = downloadUrl;
   } else {
      objectUrl = window.URL.createObjectURL(downloadUrl);
      link.href = objectUrl;
   }
   link.download = fileName;
   link.click();

   if (objectUrl) {
      window.URL.revokeObjectURL(objectUrl);
   }
}

/**
 *
 * Helper function to compress files on the client side
 *
 */
async function compressFiles(files) {
   // compress files client side
   const zip = new JSZip();
   // get the files blob
   const filesBlob = await Promise.all(
      files.map(async (file) => {
         const response = await fetch(file.url);
         const blob = await response.blob();
         return { blob, name: file.name };
      })
   );
   // add files to zip
   filesBlob.forEach((file) => {
      zip.file(file.name, file.blob);
   });
   // generate zip file
   const content = await zip.generateAsync({ type: 'blob' });
   return content;
}
